import { appConfig } from "src/config";
import { LibCategories } from "src/utils/consent";
import { loadScript } from "src/utils/scriptLoader";

export function loadOptimizely() {
  const optimizelyProjectId = appConfig.OPTIMIZELY_PROJECT_ID_EN;

  return loadScript(
    "https://cdnjs.cloudflare.com/ajax/libs/jquery/3.4.1/jquery.min.js",
    [LibCategories.functionalCookies]
  ).then(() =>
    loadScript(`https://cdn.optimizely.com/js/${optimizelyProjectId}.js`, [
      LibCategories.functionalCookies,
    ])
  );
}
